/**
 * @generated SignedSource<<54ad49c0722cf567c8a7a738ad0f7833>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type persologElementQuestionsEditor_QuestionsFragment$data = {
  readonly id: string;
  readonly questions: ReadonlyArray<{
    readonly id: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"persologElementQuestionFormDialog_QuestionFragment">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"persologElementQuestionFormDialog_PersologElementFragment">;
  readonly " $fragmentType": "persologElementQuestionsEditor_QuestionsFragment";
};
export type persologElementQuestionsEditor_QuestionsFragment$key = {
  readonly " $data"?: persologElementQuestionsEditor_QuestionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"persologElementQuestionsEditor_QuestionsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "persologElementQuestionsEditor_QuestionsFragment",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "persologElementQuestionFormDialog_PersologElementFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Persolog_Question",
      "kind": "LinkedField",
      "name": "questions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "persologElementQuestionFormDialog_QuestionFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Persolog_PersologElement",
  "abstractKey": null
};
})();

(node as any).hash = "f8173d97157240bda2f59eea5d01f9d7";

export default node;
